import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { cn } from '@mmscan/angular-ui/core';
import { cva, type VariantProps } from 'class-variance-authority';

export const skeletonVariants = cva('block animate-pulse bg-border motion-reduce:animate-none', {
  variants: {
    shape: {
      rect: 'rounded-md',
      circle: 'rounded-full',
      text: 'h-4 w-full rounded-sm',
    },
  },
  defaultVariants: { shape: 'rect' },
});

export type SkeletonShape = NonNullable<VariantProps<typeof skeletonVariants>['shape']>;

/**
 * Placeholder while content loads. Size it with classes: `<mmscan-skeleton class="h-24 w-full" />`.
 * Hidden from assistive tech — announce loading with `mmscan-spinner` or `aria-busy` on the region.
 */
@Component({
  selector: 'mmscan-skeleton',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'aria-hidden': 'true',
    '[class]': 'classes()',
  },
})
export class MmscanSkeleton {
  readonly shape = input<SkeletonShape>('rect');
  readonly class = input<string>('');

  protected readonly classes = computed(() => cn(skeletonVariants({ shape: this.shape() }), this.class()));
}
